import $ from "jquery";
import React, { Component } from "react";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { showError: false };
    }

    KeyDown(event) {
        if (event.keyCode === 13) this.Login();
    }

    Login() {
        var ctx = Comm.Login($("#tbLogin").val(), $("#tbPassword").val());
        if (ctx !== null) {
            let sid = ctx.Sid;
            ctx = Comm.SessionUser(sid);
            ctx.username = $("#tbLogin").val();
            ctx.isAdmin = $("#tbLogin").val().toLowerCase() === "admin";
            ctx.Sid = sid;
            Context.Login(ctx);

            //var groups = Comm.User(ctx.Sid, 1);
            //document.location.href = "/adminmenu";
            // if (!Context.HasRight("rtax") || Context.ctx.username === "admin")
            this.props.history.push("/adminmenu");
            // else this.props.history.push("/n18odit");
        } else {
            this.setState({ showError: true });
        }
    }

    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("login")} test</div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        this.Login();
                    }}
                    className="panel-body"
                >
                    <input
                        id="tbLogin"
                        type="text"
                        name="tbLogin"
                        className="form-control"
                        autoComplete="curr-username"
                        placeholder={Translation.Trans("username")}
                        onKeyDown={(event) => this.KeyDown(event)}
                    />
                    <br />
                    <input
                        id="tbPassword"
                        type="password"
                        name="tbPassword"
                        className="form-control"
                        autoComplete="curr-password"
                        placeholder={Translation.Trans("password")}
                        onKeyDown={(event) => this.KeyDown(event)}
                    />
                    <br />
                    <button type="submit" className="btn btn-primary">
                        {Translation.Trans("login")}
                    </button>
                    <br />
                    {this.state.showError ? (
                        <div className="alert alert-danger">
                            {Translation.Trans("invalidusernameorpassword")}
                        </div>
                    ) : null}
                </form>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login.js